// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CanvasView.module.css — canvas-only styles.
   Shared atoms live in shared.module.css. */

.CanvasView_canvasContainer__\\+e7i8 { padding: 20px 0; }
.CanvasView_canvasGrid__xLE8H { display: flex; flex-direction: column; gap: 30px; }

.CanvasView_canvasCard__skqmw {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8e8e8;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.04),
    0 2px 4px rgba(0, 0, 0, 0.02);
  position: relative;
  border-left: 4px solid #1a73e8;
  min-height: 460px;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: visible;   /* ← was: hidden */
}

.CanvasView_canvasChain__WEVfr { padding: 20px; }

.CanvasView_canvasHeader__a2qH9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.CanvasView_canvasChainInfo__l2S8O { display: flex; align-items: center; gap: 12px; }
.CanvasView_canvasChainName__WcjmQ { margin: 0; font-size: 18px; font-weight: 600; color: #1a1a2e; }
.CanvasView_canvasActions__sfE8- { display: flex; gap: 8px; flex-shrink: 0; }

.CanvasView_canvasFlow__Btkc6 {
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 20px 0;
  overflow-x: auto;
  min-height: 200px;
}

.CanvasView_canvasStep__eN9jJ {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}

.CanvasView_canvasStartNode__2jDrb {
  flex: 0 0 auto;
  padding: 12px 16px;
  background: #f7fafc;
  border-radius: 12px;
  border: 1px dashed #cbd5e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 140px;
}

/* ── Filmstrip ── */
.CanvasView_filmstripOuter__8FZWa {
  display: flex;
  align-items: stretch;
  gap: 8px;
  position: relative;
  padding: 12px 4px;
}

.CanvasView_filmstrip__03O6q {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 12px 8px;
  flex: 1 1;
  min-width: 0;
  scroll-snap-type: x proximity;
}

.CanvasView_filmstrip__03O6q > * { scroll-snap-align: center; }

.CanvasView_filmstrip__03O6q::-webkit-scrollbar { height: 6px; }
.CanvasView_filmstrip__03O6q::-webkit-scrollbar-track { background: transparent; }
.CanvasView_filmstrip__03O6q::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 3px; }
.CanvasView_filmstrip__03O6q::-webkit-scrollbar-thumb:hover { background: #a0aec0; }

.CanvasView_stripNavBtn__S3A0H {
  flex: 0 0 auto;
  width: 36px;
  align-self: center;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #4a5568;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: all 0.15s ease;
}

.CanvasView_stripNavBtn__S3A0H:hover:not(:disabled) {
  background: #f7fafc;
  border-color: #93b4e8;
  color: #1a73e8;
}

.CanvasView_stripNavBtn__S3A0H:disabled { opacity: 0.35; cursor: not-allowed; }

/* ── Arrow connector as a clickable pill ─────────────────── */

.CanvasView_edgeArrowBtn__zQC5y {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 6px 8px;
  border-radius: 20px;
  border: 1px solid #cbd5e0;
  background: #ffffff;
  color: #4a5568;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  align-self: center;
  margin: 0 4px;
  font-family: inherit;
}

.CanvasView_edgeArrowBtn__zQC5y:hover {
  border-color: #1a73e8;
  color: #1a4fa0;
  background: #f8fbff;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(26, 115, 232, 0.15);
}

.CanvasView_edgeArrowBtn__zQC5y:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.18);
}

.CanvasView_edgeArrowBtnStatus__Z4bMz {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 10px;
  background: #edf2f7;
  color: #2d3748;
  transition: all 0.15s ease;
}

/* Status class overrides — mirror the tree-row pills */
.CanvasView_edgeArrowBtnStatus__Z4bMz.CanvasView_s2xx__WGo\\+-    { background: #e6f4ea; color: #1e7e34; }
.CanvasView_edgeArrowBtnStatus__Z4bMz.CanvasView_s3xx__vxUKl    { background: #e8f0fe; color: #1a4fa0; }
.CanvasView_edgeArrowBtnStatus__Z4bMz.CanvasView_s4xx__tSQRa    { background: #fff2e0; color: #9a5b00; }
.CanvasView_edgeArrowBtnStatus__Z4bMz.CanvasView_s5xx__SHiIJ    { background: #fce8e6; color: #c5221f; }
.CanvasView_edgeArrowBtnStatus__Z4bMz.CanvasView_sDefault__zE8DU { background: #fefcbf; color: #744210; }

.CanvasView_edgeArrowBtnArrow__xsbMC {
  color: #a0aec0;
  font-size: 12px;
  margin: 0 -2px;
  transition: color 0.15s ease;
}

.CanvasView_edgeArrowBtn__zQC5y:hover .CanvasView_edgeArrowBtnArrow__xsbMC { color: #1a73e8; }

.CanvasView_edgeArrowBtnLabel__xPkHz { color: inherit; }

.CanvasView_edgeArrowBtnIcon__KBvBr {
  color: #9f7aea;
  font-size: 12px;
  margin-left: -2px;
  transition: color 0.15s ease;
}

/* Variants */

.CanvasView_edgeArrowBtnDone__rRyLp {
  border-color: #b7e1c0;
  background: #f6fdf9;
}

.CanvasView_edgeArrowBtnDone__rRyLp .CanvasView_edgeArrowBtnStatus__Z4bMz {
  background: #e6f4ea;
  color: #1e7e34;
}

.CanvasView_edgeArrowBtnPending__rgwjB {
  border-color: #ffe082;
  background: #fffdf4;
}

.CanvasView_edgeArrowBtnPending__rgwjB .CanvasView_edgeArrowBtnStatus__Z4bMz {
  background: #fff8e1;
  color: #8a6d00;
}

/* Active (panel open) — very visible blue */

.CanvasView_edgeArrowBtnActive__4he36,
.CanvasView_edgeArrowBtnActive__4he36:hover {
  border-color: #1a73e8;
  background: #e8f0fe;
  color: #1a4fa0;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.18);
  transform: translateY(-1px);
}

.CanvasView_edgeArrowBtnActive__4he36 .CanvasView_edgeArrowBtnArrow__xsbMC { color: #1a73e8; }
.CanvasView_edgeArrowBtnActive__4he36 .CanvasView_edgeArrowBtnIcon__KBvBr { color: #1a73e8; }

/* ── Mapping panel — sticky to the bottom of the canvas card ── */

.CanvasView_mappingPanelHost__IZV\\+m {
  position: static;          /* ← was: sticky */
  z-index: 1;
  background: #ffffff;
  border-top: 3px solid #1a73e8;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
  padding: 18px 24px 22px;
  max-height: 65vh;
  overflow-y: auto;
  margin-top: 12px;
  /* No absolute, no sticky — it just becomes part of the card's flow
     and pushes the card taller when it opens. */
}

.CanvasView_mappingPanelHeader__BcTBw {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #e2e8f0;
  font-size: 13px;
  color: #4a5568;
}

.CanvasView_mappingPanelHeaderStrong__AO2-s { font-weight: 700; color: #2d3748; }

.CanvasView_mappingPanelClose__8Yir1 {
  margin-left: auto;
  background: none;
  border: none;
  color: #718096;
  font-size: 12px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.15s ease;
}

.CanvasView_mappingPanelClose__8Yir1:hover { background: #edf2f7; color: #2d3748; }

.CanvasView_mappingPanelBody__Nt11I { max-width: 1100px; }

/* ── Responsive ── */

@media (max-width: 900px) {
  .CanvasView_canvasCard2__GUrMV { min-width: 220px; max-width: 240px; }
  .CanvasView_canvasStartNode__2jDrb { min-width: 110px; }
  .CanvasView_edgeArrowBtnLabel__xPkHz { display: none; }
}

@media (max-width: 640px) {
  .CanvasView_canvasCard2__GUrMV { min-width: 200px; }
  .CanvasView_edgeArrowBtnIcon__KBvBr { display: none; }
  .CanvasView_mappingPanelHost__IZV\\+m { padding: 14px 16px 18px; }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/CanvasView.module.css"],"names":[],"mappings":"AAAA;4CAC4C;;AAE5C,sCAAmB,eAAe,EAAE;AACpC,gCAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEhE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB;;iCAE+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB,IAAI,kBAAkB;AACzC;;AAEA,iCAAe,aAAa,EAAE;;AAE9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,qCAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAClE,qCAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACjF,mCAAiB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,mCAAiB,yBAAyB,EAAE;;AAE5C,kDAAgC,WAAW,EAAE;AAC7C,wDAAsC,uBAAuB,EAAE;AAC/D,wDAAsC,mBAAmB,EAAE,kBAAkB,EAAE;AAC/E,8DAA4C,mBAAmB,EAAE;;AAEjE;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0CAAwB,aAAa,EAAE,mBAAmB,EAAE;;AAE5D,+DAA+D;;AAE/D;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,uDAAuD;AACvD,mEAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,kEAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,kEAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,kEAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,mEAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA,6EAAyC,cAAc,EAAE;;AAEzD,uCAAqB,cAAc,EAAE;;AAErC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,aAAa;;AAEb;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4CAA4C;;AAE5C;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,6EAAyC,cAAc,EAAE;AACzD,4EAAwC,cAAc,EAAE;;AAExD,kEAAkE;;AAElE;EACE,gBAAgB,WAAW,kBAAkB;EAC7C,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;gDAC8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA,8CAA4B,gBAAgB,EAAE,cAAc,EAAE;;AAE9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA,6CAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,sCAAoB,iBAAiB,EAAE;;AAEvC,qBAAqB;;AAErB;EACE,iCAAe,gBAAgB,EAAE,gBAAgB,EAAE;EACnD,qCAAmB,gBAAgB,EAAE;EACrC,uCAAqB,aAAa,EAAE;AACtC;;AAEA;EACE,iCAAe,gBAAgB,EAAE;EACjC,sCAAoB,aAAa,EAAE;EACnC,uCAAoB,uBAAuB,EAAE;AAC/C","sourcesContent":["/* CanvasView.module.css — canvas-only styles.\n   Shared atoms live in shared.module.css. */\n\n.canvasContainer { padding: 20px 0; }\n.canvasGrid { display: flex; flex-direction: column; gap: 30px; }\n\n.canvasCard {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e8e8e8;\n  box-shadow:\n    0 4px 12px rgba(0, 0, 0, 0.04),\n    0 2px 4px rgba(0, 0, 0, 0.02);\n  position: relative;\n  border-left: 4px solid #1a73e8;\n  min-height: 460px;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;   /* ← was: hidden */\n}\n\n.canvasChain { padding: 20px; }\n\n.canvasHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.canvasChainInfo { display: flex; align-items: center; gap: 12px; }\n.canvasChainName { margin: 0; font-size: 18px; font-weight: 600; color: #1a1a2e; }\n.canvasActions { display: flex; gap: 8px; flex-shrink: 0; }\n\n.canvasFlow {\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n  padding: 20px 0;\n  overflow-x: auto;\n  min-height: 200px;\n}\n\n.canvasStep {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 auto;\n}\n\n.canvasStartNode {\n  flex: 0 0 auto;\n  padding: 12px 16px;\n  background: #f7fafc;\n  border-radius: 12px;\n  border: 1px dashed #cbd5e0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-width: 140px;\n}\n\n/* ── Filmstrip ── */\n.filmstripOuter {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  position: relative;\n  padding: 12px 4px;\n}\n\n.filmstrip {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 12px 8px;\n  flex: 1;\n  min-width: 0;\n  scroll-snap-type: x proximity;\n}\n\n.filmstrip > * { scroll-snap-align: center; }\n\n.filmstrip::-webkit-scrollbar { height: 6px; }\n.filmstrip::-webkit-scrollbar-track { background: transparent; }\n.filmstrip::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 3px; }\n.filmstrip::-webkit-scrollbar-thumb:hover { background: #a0aec0; }\n\n.stripNavBtn {\n  flex: 0 0 auto;\n  width: 36px;\n  align-self: center;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #4a5568;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  transition: all 0.15s ease;\n}\n\n.stripNavBtn:hover:not(:disabled) {\n  background: #f7fafc;\n  border-color: #93b4e8;\n  color: #1a73e8;\n}\n\n.stripNavBtn:disabled { opacity: 0.35; cursor: not-allowed; }\n\n/* ── Arrow connector as a clickable pill ─────────────────── */\n\n.edgeArrowBtn {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px 6px 8px;\n  border-radius: 20px;\n  border: 1px solid #cbd5e0;\n  background: #ffffff;\n  color: #4a5568;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  white-space: nowrap;\n  align-self: center;\n  margin: 0 4px;\n  font-family: inherit;\n}\n\n.edgeArrowBtn:hover {\n  border-color: #1a73e8;\n  color: #1a4fa0;\n  background: #f8fbff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(26, 115, 232, 0.15);\n}\n\n.edgeArrowBtn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.18);\n}\n\n.edgeArrowBtnStatus {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 10px;\n  background: #edf2f7;\n  color: #2d3748;\n  transition: all 0.15s ease;\n}\n\n/* Status class overrides — mirror the tree-row pills */\n.edgeArrowBtnStatus.s2xx    { background: #e6f4ea; color: #1e7e34; }\n.edgeArrowBtnStatus.s3xx    { background: #e8f0fe; color: #1a4fa0; }\n.edgeArrowBtnStatus.s4xx    { background: #fff2e0; color: #9a5b00; }\n.edgeArrowBtnStatus.s5xx    { background: #fce8e6; color: #c5221f; }\n.edgeArrowBtnStatus.sDefault { background: #fefcbf; color: #744210; }\n\n.edgeArrowBtnArrow {\n  color: #a0aec0;\n  font-size: 12px;\n  margin: 0 -2px;\n  transition: color 0.15s ease;\n}\n\n.edgeArrowBtn:hover .edgeArrowBtnArrow { color: #1a73e8; }\n\n.edgeArrowBtnLabel { color: inherit; }\n\n.edgeArrowBtnIcon {\n  color: #9f7aea;\n  font-size: 12px;\n  margin-left: -2px;\n  transition: color 0.15s ease;\n}\n\n/* Variants */\n\n.edgeArrowBtnDone {\n  border-color: #b7e1c0;\n  background: #f6fdf9;\n}\n\n.edgeArrowBtnDone .edgeArrowBtnStatus {\n  background: #e6f4ea;\n  color: #1e7e34;\n}\n\n.edgeArrowBtnPending {\n  border-color: #ffe082;\n  background: #fffdf4;\n}\n\n.edgeArrowBtnPending .edgeArrowBtnStatus {\n  background: #fff8e1;\n  color: #8a6d00;\n}\n\n/* Active (panel open) — very visible blue */\n\n.edgeArrowBtnActive,\n.edgeArrowBtnActive:hover {\n  border-color: #1a73e8;\n  background: #e8f0fe;\n  color: #1a4fa0;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.18);\n  transform: translateY(-1px);\n}\n\n.edgeArrowBtnActive .edgeArrowBtnArrow { color: #1a73e8; }\n.edgeArrowBtnActive .edgeArrowBtnIcon { color: #1a73e8; }\n\n/* ── Mapping panel — sticky to the bottom of the canvas card ── */\n\n.mappingPanelHost {\n  position: static;          /* ← was: sticky */\n  z-index: 1;\n  background: #ffffff;\n  border-top: 3px solid #1a73e8;\n  border-radius: 0 0 12px 12px;\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);\n  padding: 18px 24px 22px;\n  max-height: 65vh;\n  overflow-y: auto;\n  margin-top: 12px;\n  /* No absolute, no sticky — it just becomes part of the card's flow\n     and pushes the card taller when it opens. */\n}\n\n.mappingPanelHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px dashed #e2e8f0;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.mappingPanelHeaderStrong { font-weight: 700; color: #2d3748; }\n\n.mappingPanelClose {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #718096;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.15s ease;\n}\n\n.mappingPanelClose:hover { background: #edf2f7; color: #2d3748; }\n\n.mappingPanelBody { max-width: 1100px; }\n\n/* ── Responsive ── */\n\n@media (max-width: 900px) {\n  .canvasCard2 { min-width: 220px; max-width: 240px; }\n  .canvasStartNode { min-width: 110px; }\n  .edgeArrowBtnLabel { display: none; }\n}\n\n@media (max-width: 640px) {\n  .canvasCard2 { min-width: 200px; }\n  .edgeArrowBtnIcon { display: none; }\n  .mappingPanelHost { padding: 14px 16px 18px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvasContainer": `CanvasView_canvasContainer__+e7i8`,
	"canvasGrid": `CanvasView_canvasGrid__xLE8H`,
	"canvasCard": `CanvasView_canvasCard__skqmw`,
	"canvasChain": `CanvasView_canvasChain__WEVfr`,
	"canvasHeader": `CanvasView_canvasHeader__a2qH9`,
	"canvasChainInfo": `CanvasView_canvasChainInfo__l2S8O`,
	"canvasChainName": `CanvasView_canvasChainName__WcjmQ`,
	"canvasActions": `CanvasView_canvasActions__sfE8-`,
	"canvasFlow": `CanvasView_canvasFlow__Btkc6`,
	"canvasStep": `CanvasView_canvasStep__eN9jJ`,
	"canvasStartNode": `CanvasView_canvasStartNode__2jDrb`,
	"filmstripOuter": `CanvasView_filmstripOuter__8FZWa`,
	"filmstrip": `CanvasView_filmstrip__03O6q`,
	"stripNavBtn": `CanvasView_stripNavBtn__S3A0H`,
	"edgeArrowBtn": `CanvasView_edgeArrowBtn__zQC5y`,
	"edgeArrowBtnStatus": `CanvasView_edgeArrowBtnStatus__Z4bMz`,
	"s2xx": `CanvasView_s2xx__WGo+-`,
	"s3xx": `CanvasView_s3xx__vxUKl`,
	"s4xx": `CanvasView_s4xx__tSQRa`,
	"s5xx": `CanvasView_s5xx__SHiIJ`,
	"sDefault": `CanvasView_sDefault__zE8DU`,
	"edgeArrowBtnArrow": `CanvasView_edgeArrowBtnArrow__xsbMC`,
	"edgeArrowBtnLabel": `CanvasView_edgeArrowBtnLabel__xPkHz`,
	"edgeArrowBtnIcon": `CanvasView_edgeArrowBtnIcon__KBvBr`,
	"edgeArrowBtnDone": `CanvasView_edgeArrowBtnDone__rRyLp`,
	"edgeArrowBtnPending": `CanvasView_edgeArrowBtnPending__rgwjB`,
	"edgeArrowBtnActive": `CanvasView_edgeArrowBtnActive__4he36`,
	"mappingPanelHost": `CanvasView_mappingPanelHost__IZV+m`,
	"mappingPanelHeader": `CanvasView_mappingPanelHeader__BcTBw`,
	"mappingPanelHeaderStrong": `CanvasView_mappingPanelHeaderStrong__AO2-s`,
	"mappingPanelClose": `CanvasView_mappingPanelClose__8Yir1`,
	"mappingPanelBody": `CanvasView_mappingPanelBody__Nt11I`,
	"canvasCard2": `CanvasView_canvasCard2__GUrMV`
};
export default ___CSS_LOADER_EXPORT___;
